// extracted by mini-css-extract-plugin
export default {"H1":"aXPoST_Pk7Jyau3ufyZ3","H2":"izj4Oafnk99eatE0gkdp","H3":"fvz5_P6PDQ8mQ6soCm1G","H4":"Idnfip2MX78tZbWEpnB1","H5":"e1zw_idpKNv004My9P8I","H6":"H7sgxea7OyRjPxRPxCwg"};